import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GlobalConstants} from '../global-constants';
import {SortDirection} from "@angular/material/sort";
import {stringify, parse} from 'zipson';
import {Location, SearchFilters} from "./location.models";

@Injectable({
    providedIn: 'root'
})
export class LocationService {

    constructor(private http: HttpClient) {
    }

    findAll() {
        return this.http.get(`${GlobalConstants.apiURL}/locations`);
    }

    find(sort: string, order: SortDirection, page: number, size: number, search, hideInactive = true, showFailedOnly = false) {
        const sortParameter = sort ? `&sort=${sort},${order}` : '';
        const searchParameter = search ? `&search=${search}` : '';
        return this.http.get(`${GlobalConstants.apiURL}/locations/find?page=${page}&size=${size}&hideInactive=${hideInactive}&showFailedOnly=${showFailedOnly}${sortParameter}${searchParameter}`);
    }

    activate(id, active) {
        return this.http.post(`${GlobalConstants.apiURL}/locations/activate?locationId=${id}&active=${active}`, {});
    }

    create(location: Location) {
        return this.http.post(`${GlobalConstants.apiURL}/locations/create`, location);
    }

    delete(id: string) {
        return this.http.delete(`${GlobalConstants.apiURL}/locations/delete/${id}`);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FiltersService {

    static readonly LOCAL_STORAGE_FILTERS_ITEM_NAME = 'rb-revenue-filters';

    getFilters(suffix): SearchFilters {
        let result = {
            searchQuery: {value: ''},
            location: {value: ''},
            jobStatus: {value: ''},
            jobType: {value: ''},
            status: {value: ''},
        } as SearchFilters;
        const cachedFiltersStr = localStorage.getItem(FiltersService.LOCAL_STORAGE_FILTERS_ITEM_NAME + '-' + suffix);
        if (cachedFiltersStr) {
            try {
                result = parse(cachedFiltersStr) as SearchFilters;
            } catch (e) {
            }
        }
        return result
    }

    saveFilters(filters: SearchFilters, suffix) {
        localStorage.setItem(FiltersService.LOCAL_STORAGE_FILTERS_ITEM_NAME + '-' + suffix, stringify(filters));
    }

    buildSearchParam(filters: SearchFilters) {
        let result = '';
        for (const [key, value] of Object.entries(filters)) {
            result += value.value ? `${key}:${value.value},` : '';
        }
        return result;
    }

    resetFilters(suffix) {
        localStorage.removeItem(FiltersService.LOCAL_STORAGE_FILTERS_ITEM_NAME + '-' + suffix);
    }
}

